import {stringify} from 'qs'
let root = ''
if (process.env.NODE_ENV === 'development') {
  root = '//10.10.0.213:8082'
} else if (process.env.NODE_ENV === 'production') {
  root = '//www.shiyipic.com/api'
}
export function ajaxFetch (method, url, body, success, failure) {
  method = method.toUpperCase()
  fetch(root + url, {
    method: method,
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }),
    body: stringify(body)
  }).then(function (response) {
    if (response.status !== 200) {
      console.log(response)
      console.error('存在一个问题:' + response.status)
      return
    }
    response.json().then(function (data) {
      success(data)
    })
  }, function (error) {
    failure(error)
    console.log(error.message) // => String
  })
}
export function ajaxFetchFile (method, url, body, success, failure) {
  method = method.toUpperCase()
  fetch(root + url, {
    method: method,
    mode: 'cors',
    body: body
  }).then(function (response) {
    if (response.status !== 200) {
      console.log(response)
      console.error('存在一个问题:' + response.status)
      return
    }
    response.json().then(function (data) {
      success(data)
    })
  }, function (error) {
    failure(error)
    console.log(error.message) // => String
  })
}



// WEBPACK FOOTER //
// ./src/utils.js